import AppContext from "PFApp/app_context";
import { useContext } from "react";

type UseBackgroundColor = {
  availableMinutes: number;
};

export const useBackgroundColor = ({ availableMinutes }: UseBackgroundColor): string => {
  const {
    store: { themeVars }
  } = useContext(AppContext);

  if (availableMinutes === 0) {
    return themeVars["--Palette-text-light"];
  }
  if (availableMinutes > 0) {
    return themeVars["--Palette-neutral"];
  }

  return themeVars["--Palette-text"];
};
